/**
 * Utility functions for ENS (Ethereum Name Service)
 */

/**
 * Checks if a string is a potential ENS name
 * All dot-separated strings are considered potential ENS names
 * (not just .eth domains)
 *
 * @param name The name to check
 * @returns True if the name is a potential ENS name (contains a dot)
 */
export const isPotentialENSName = (name: string): boolean => {
    if (!name) return false
    return name.toLowerCase().includes('.')
}
